/**
 * @param warehousecode
 * @returns string
 * @example tranformWareHouse('CNDGMA');
 */

import { WarehouseList } from '@/components/WarehouseSelect/index.interface';

interface Options {
  valueName: string;
  labelName: string;
}

const getWarehouseNameByType = (warehousecode: string, type = 'allWarehouseList') => {
  const str: string = window.sessionStorage.getItem(type) || '';
  if (!str) return '';
  const wareHouseList: [] = JSON.parse(str);
  if (!wareHouseList?.length) return warehousecode;
  let val = '';
  wareHouseList?.forEach((e: WarehouseList) => {
    e?.warehouses?.map((d) => {
      if (warehousecode === d?.code) {
        val = d.name;
      }
    });
  });
  return val;
};

export { getWarehouseNameByType };
